import React, { useContext } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContexts';
import { types } from '../../types/types';

export const Navbar = () => {

  const { user: { name },dispatch} = useContext(AuthContext);
  const history = useHistory(); 
  //esto no va a resolverla vida para no tener que mandarle la prop al dash rauter luego la navlink
  // console.log(history)

  const handleLogout = () => {
    
    history.replace('/login')

    dispatch({
      type:types.logout,
      user:'',
      logged:false,
    });


  }

  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
      <Link className="navbar-brand" to="/">
        HeroesWiki
      </Link>

      <div className="navbar-collapse">
        <div className="navbar-nav">
          <NavLink
            activeClassName="active"
            className="nav-item nav-link"
            exact
            to="/marvel"
          >
            Marvel
          </NavLink>

          <NavLink
            activeClassName="active"
            className="nav-item nav-link"
            exact
            to="/dc"
          >
            DC
          </NavLink>

          <Link className="nav-item nav-link" exact to="/search">
            Buscar
          </Link>
        </div>
      </div>

      <div className="navbar-collapse collapse w-100 order-3 dual-collapse2">
        <ul className="navbar-nav ml-auto">
          <strong className="nav-item nav-link text-info">{name}</strong>
          <button
            className="nav-item nav-link btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </ul>
      </div>
    </nav>
  );
};
